import React from 'react';
import classNames from 'classnames';
import InputLabel from '@material-ui/core/InputLabel';
import Typography from '@material-ui/core/Typography';
import moment from 'moment';
import withStyles from '@material-ui/core/styles/withStyles';
import PropTypes from 'prop-types';
import { monthYear } from 'Consts/DateFormats';

const styles = theme => ({
  root: {
    position: 'relative',
    paddingBottom: theme.spacing(2.5),
  },
});

const ReadOnlyDateMonthYear = ({
  value, label, classes, className,
}) => {
  return (
    <div className={classNames(classes.root, className)}>
      <InputLabel>{label}</InputLabel>
      <Typography
        color="primaryGray"
        variant="h5"
      >
        {value && moment(value).format(monthYear)}
      </Typography>
    </div>
  );
};

ReadOnlyDateMonthYear.defaultProps = {
  value: null,
  className: '',
};

ReadOnlyDateMonthYear.propTypes = {
  value: PropTypes.object,
  className: PropTypes.string,
  label: PropTypes.string.isRequired,
  classes: PropTypes.string.isRequired,
};

export default withStyles(styles)(ReadOnlyDateMonthYear);
